import Vue from 'vue'
import Router from 'vue-router'

// import Home from '@/pages/layout/home.vue'
import Login from '@/pages/login/main.vue'
import Home from '@/pages/home/realHome.vue'
import realHome from '@/pages/home/realHome.vue'
import HomeJx from '@/pages/home/homeJx.vue'
import StudyCentre from '@/pages/studyCentre/studyCentre.vue'
import PublicCourse from '@/pages/publicCourse/publicCourse.vue'
import News from '@/pages/news/news.vue'
import Notice from '@/pages/notice/notice.vue'
// import CourseDetail from '@/pages/courseDetail/courseDetail.vue'
import CourseDetail from '@/pages/courseDetailNew/courseDetail.vue'
import NoticeDetail from '@/pages/noticeDetail/noticeDetail.vue'
import NewsDetail from '@/pages/newsDetail/newsDetail.vue'
import UserCenter from '@/pages/userCenter/userCenter.vue'
import CoursePlay from '@/pages/coursePlay2/coursePlay.vue'
import CoursePlayNew from '@/pages/coursePlayNew/coursePlay.vue'
import OneBannerDetail from '@/pages/banner1/banner.vue'
import TwoBannerDetail from '@/pages/banner2/banner.vue'
import ThreeBannerDetail from '@/pages/banner3/banner.vue'
import exam from '@/pages/exam/exam.vue'
import examList from '@/pages/examList/examList.vue'
import testList from '@/pages/testList/testList.vue'
import examDetail from '@/pages/examDetail/examDetail.vue'
import testDetail from '@/pages/testDetail/testDetail.vue'
import otherTestRerult from '@/pages/otherTestRerult/index.vue'
import otherPracticeRerult from '@/pages/otherPracticeRerult/index.vue'
import practiceResult from '@/pages/practiceResult/practiceResult.vue'
import testResult from '@/pages/testResult/testResult.vue'
import mistakesDetail from '@/pages/mistakesDetail/mistakesDetail.vue'
import OfflineCourseDetail from '@/pages/offlineCourseDetail/offlineCourseDetail.vue'
import OfflineApply from '@/pages/offlineApply/offlineApply.vue'
import OfflineCourseList from '@/pages/offlineCourseList/offlineCourseList.vue'
import eHome from '@/pages/enterpriseEdition/eHome.vue'
import saasHtml from '@/pages/enterpriseEdition/saasHtml.vue'
import eeHtml from '@/pages/enterpriseEdition/eeHtml.vue'
import weChatHtml from '@/pages/enterpriseEdition/weChatHtml.vue'
import channelAgent from '@/pages/enterpriseEdition/channelAgent.vue'
import agencies from '@/pages/enterpriseEdition/agencies.vue'
import supplierAllBack from '@/pages/home/supplierAllBack.vue'
import intentionalPurchase from '@/pages/intentional-purchase/intentional-purchase.vue'
import intentionalPurchaseDemo from '@/pages/intentional-purchase/intentional-purchaseDemo.vue'
import Alipay from '@/pages/intentional-purchase/Alipay.vue'
import WitnessSamples from '@/pages/home/WitnessSamples.vue'
import coursePlayByPrivate from '@/pages/coursePlayByPrivate/coursePlayByPrivate.vue'
import linkUrl from '@/pages/linkUrl.vue'




// 2.0
import Service from "@/pages/service"
const livePlayback = () => import( /* webpackChunkName: "livePlayback" */ '../pages/livePlayback/livePlayback.vue')
const liveDetail = () => import( /* webpackChunkName: "liveDetail" */ '../pages/liveDetail/index.vue')



import about from '@/pages/about/about.vue'
import nullHtml from '@/pages/home/null.vue'
import tutorial from '@/pages/tutorial/tutorial.vue'

import {
  pUrl
} from "@/api/baseURL.js";
Vue.use(Router);

const isYcy = pUrl == "http://www.enterprise.eceping.net";
let ycyPath = isYcy ? '_ycy' : '';

//var pUrl="http://zhdl.enterprise.eceping.net";

// var pUrl = window.location.href;
// var pUrl = 'http://snyg.e.eceping.net';
//var pUrl="http://py.eceping.net";

var defaultUrl = {};

if (pUrl == "http://www.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://www.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://www.eceping.net:8080") { //访问www.eceping.net域名时,显示关于我们
  defaultUrl = {
    path: '/',
    redirect: "/eHome"
  }
} else if (pUrl == "http://jx.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://jx.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://jx.eceping.net:8080" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://jx.eceping.net:30001") {
  defaultUrl = {
    path: '/',
    redirect: "/HomeJx"
  }
} else {
  defaultUrl = {
    path: '/',
    redirect: "/home"

  }
}
export default new Router({
  routes: [
    defaultUrl,
    {
      path: '/home', //首页
      name: 'home',
      component: Home,
    },
    {
      path: '/WitnessSamples', //首页
      name: 'WitnessSamples',
      component: WitnessSamples,
    },
    {
      path: '/homeJx', //首页
      name: 'homeJx',
      component: HomeJx,
    },
    {
      path: '/null', //首页
      name: 'null',
      component: nullHtml,
    },
    {
      path: '/login', //登录
      name: 'login',
      component: Login,
    },
    {
      path: '/studyCentre', //学习中心
      name: 'studyCentre',
      component: StudyCentre,
    },
    {
      path: '/publicCourse', //公共课程
      name: 'publicCourse',
      component: PublicCourse,
    },
    {
      path: '/news', //新闻资讯
      name: 'news',
      component: News,
    },
    {
      path: '/notice', //消息推送
      name: 'notice',
      component: Notice
    },
    {
      path: '/noticeDetail', //消息推送
      name: 'noticeDetail',
      component: NoticeDetail,
    },
    {
      path: '/courseDetail', //课程详情
      name: 'courseDetail',
      component: CourseDetail,
    },
    {
      path: '/coursePlay', //课程视频播放
      name: 'coursePlay',
      component: CoursePlay,
    },
    {
      path: '/coursePlayNew', //试看课视频播放
      name: 'coursePlayNew',
      component: CoursePlayNew,
    },
    {
      path: '/coursePlayByPrivate', //私人课程视频播放
      name: 'coursePlayByPrivate',
      component: coursePlayByPrivate,
    },
    {
      path: '/newsDetail', //新闻详情
      name: 'newsDetail',
      component: NewsDetail,
    },
    {
      path: '/userCenter', //个人中心
      name: 'userCenter',
      component: UserCenter,
    },
    {
      path: '/oneBannerDetail', //广告1
      name: 'oneBannerDetail',
      component: OneBannerDetail,
    },
    {
      path: '/twoBannerDetail', //广告2
      name: 'twoBannerDetail',
      component: TwoBannerDetail
    },
    {
      path: '/threeBannerDetail', //广告3
      name: 'threeBannerDetail',
      component: ThreeBannerDetail
    },
    {
      path: '/exam', //考试中心
      name: 'exam',
      component: exam
    },
    {
      path: '/testList', //考试中心列表
      name: 'testList',
      component: testList
    },
    {
      path: '/examList', //考试中心列表
      name: 'examList',
      component: examList
    },
    {
      path: '/examDetail', //试卷详情
      name: 'examDetail',
      component: examDetail
    },
    {
      path: '/testDetail', //试卷详情
      name: 'testDetail',
      component: testDetail
    },
    {
      path: '/otherTestRerult', //其他结果展示
      name: 'otherTestRerult',
      component: otherTestRerult
    },
    {
      path: '/otherPracticeRerult', //其他结果展示
      name: 'otherPracticeRerult',
      component: otherPracticeRerult
    },
    {
      path: '/practiceResult', //试卷答案详情
      name: 'practiceResult',
      component: practiceResult
    },
    {
      path: '/testResult', //试卷答案详情
      name: 'testResult',
      component: testResult
    },
    {
      path: '/mistakesDetail', //错题详情
      name: 'mistakesDetail',
      component: mistakesDetail
    },
    {
      path: '/offlineCourseDetail', //线下课程详情
      name: 'offlineCourseDetail',
      component: OfflineCourseDetail
    },
    {
      path: '/offlineApply', //线下课程报名
      name: 'offlineApply',
      component: OfflineApply
    },
    {
      path: '/offlineCourseList', //线下课程库
      name: 'offlineCourseList',
      component: OfflineCourseList
    },
    {
      path: '/eHome', //企业版首页
      name: 'eHome',
      component: eHome
    },
    {
      path: '/realHome', //真正的首页
      name: 'realHome',
      component: realHome
    },
    {
      path: '/saasHtml', //SaaS版介绍
      name: 'saasHtml',
      component: saasHtml
    },
    {
      path: '/eeHtml', //企业版介绍
      name: 'eeHtml',
      component: eeHtml
    },
    {
      path: '/weChatHtml', //微信版介绍
      name: 'weChatHtml',
      component: weChatHtml
    },
    {
      path: '/channelAgent', //渠道代理
      name: 'channelAgent',
      component: channelAgent
    },
    {
      path: '/agencies', //机构合作
      name: 'agencies',
      component: agencies
    },
    {
      path: '/about', //关于我们
      name: 'about',
      component: about
    }, {
      path: '/tutorial', //学习指南
      name: 'tutorial',
      component: tutorial
    }, {
      path: '/supplierAllBack',
      name: 'supplierAllBack',
      component: supplierAllBack
    }, {
      path: '/intentional-purchase',
      name: 'intentional-purchase',
      component: intentionalPurchase
    }, {
      path: '/intentional-purchaseDemo',
      name: 'intentional-purchaseDemo',
      component: intentionalPurchaseDemo
    },
    {
      path: '/Alipay',
      name: 'Alipay',
      component: Alipay
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/livePlayback',
      name: 'livePlayback',
      component: livePlayback
    },
    {
      path: '/liveDetail',
      name: 'liveDetail',
      component: liveDetail
    },
    {
      path: '/linkUrl',
      name: 'linkUrl',
      component: linkUrl
    },
    
    {
      path: "/technical",
      redirect: '/technical/training1',
      component: (resolve) => require(["../pages/technical" + ycyPath + "/index"], resolve),
      children: [{
          path: "training1",
          component: (resolve) =>
            require(["../pages/technical" + ycyPath + "/training1"], resolve),
        },
        {
          path: "training2",
          component: (resolve) =>
            require(["../pages/technical" + ycyPath + "/training2"], resolve),
        },
        {
          path: "training3",
          component: (resolve) =>
            require(["../pages/technical" + ycyPath + "/training3"], resolve),
        },
        {
          path: "training4",
          component: (resolve) =>
            require(["../pages/technical" + ycyPath + "/training4"], resolve),
        },
        {
          path: "training5",
          component: (resolve) =>
            require(["../pages/technical" + ycyPath + "/training5"], resolve),
        },
        {
          path: "training6",
          component: (resolve) =>
            require(["../pages/technical" + ycyPath + "/training6"], resolve),
        },
        {
          path: "training7",
          component: (resolve) =>
            require(["../pages/technical" + ycyPath + "/training7"], resolve),
        },
        {
          path: "training8",
          component: (resolve) =>
            require(["../pages/technical" + ycyPath + "/training8"], resolve),
        },
        {
          path: "training9",
          component: (resolve) =>
            require(["../pages/technical" + ycyPath + "/training9"], resolve),
        },
        {
          path: "training10",
          component: (resolve) =>
            require(["../pages/technical" + ycyPath + "/training10"], resolve),
        },
      ],
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js